/**
 * SessionCustomFieldService
 * Service for managing special-session custom-field definitions
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for special-session custom-field definition CRUD operations. Read views are enriched
 * with the resolved shared CustomFieldType (name/color/icon/data-kind).
 */
export class SessionCustomFieldService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? SessionCustomFieldService.DEFAULT_SERVICE_PATH,
            basePath: SessionCustomFieldService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Get all custom-field definitions for a course session (enriched views). */
    async byCourseSession(courseSessionId) {
        const response = await this.byCourseSessionRaw(courseSessionId);
        return response.data ?? [];
    }
    byCourseSessionRaw(courseSessionId) {
        return this.http.get(this.buildUrl(`by-course-session/${courseSessionId}`));
    }
    /** Get a single custom-field definition (enriched view). */
    async getView(id) {
        const response = await this.getViewRaw(id);
        if (!response.data)
            throw new Error(`Session custom field ${id} not found`);
        return response.data;
    }
    getViewRaw(id) {
        return this.http.get(this.buildUrl(`${id}`));
    }
}
SessionCustomFieldService.DEFAULT_SERVICE_PATH = 'ac-courses';
SessionCustomFieldService.BASE_PATH = 'api/session-custom-fields';
//# sourceMappingURL=SessionCustomFieldService.js.map